import { useState } from 'react';
import { Modal, Button, Form, Alert, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-8685c875a9/icons';
import { updatePassword } from '../../../services/userService';

const ChangePassword = ({ show, handleClose }) => {
    const [formData, setFormData] = useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: ""
    });

    const [showCurrent, setShowCurrent] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [error, setError] = useState("");


    const validatePasswordStrength = (password) => {
        const minLength = /.{8,}/;
        const upper = /[A-Z]/;
        const lower = /[a-z]/;
        const number = /[0-9]/;
        const symbol = /[^A-Za-z0-9]/;

        if (!minLength.test(password)) {
            return "Password must be at least 8 characters long.";
        }
        if (!upper.test(password)) {
            return "Password must contain at least one uppercase letter.";
        }
        if (!lower.test(password)) {
            return "Password must contain at least one lowercase letter.";
        }
        if (!number.test(password)) {
            return "Password must contain at least one number.";
        }
        if (!symbol.test(password)) {
            return "Password must contain at least one special character.";
        }
        return null;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSave = () => {

        const strengthError = validatePasswordStrength(formData.newPassword);
        if (strengthError) {
            setError(strengthError);
            return;
        }


        if (formData.newPassword !== formData.confirmPassword) {
            setError("New password and confirm password do not match.");
            return;
        }

        setError("");

        updatePassword(formData);
        handleClose();
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <div className="component p-0 m-0 rounded">
                <Modal.Header closeButton>
                    <Modal.Title>Update Password</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error && <Alert variant="danger">{error}</Alert>}
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Current password</Form.Label>
                            <InputGroup className="bg-white">
                                <Form.Control
                                    type={showCurrent ? "text" : "password"}
                                    name="currentPassword"
                                    value={formData.currentPassword}
                                    onChange={handleChange}
                                />
                                <Button
                                    variant="outline-secondary"
                                    onClick={() => setShowCurrent(!showCurrent)}
                                >
                                    <FontAwesomeIcon icon={byPrefixAndName.fas[showCurrent ? 'eye-slash' : 'eye']} />
                                </Button>
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>New password</Form.Label>
                            <InputGroup className="bg-white">
                                <Form.Control
                                    type={showNew ? "text" : "password"}
                                    name="newPassword"
                                    value={formData.newPassword}
                                    onChange={handleChange}
                                />
                                <Button
                                    variant="outline-secondary"
                                    onClick={() => setShowNew(!showNew)}
                                >
                                    <FontAwesomeIcon icon={byPrefixAndName.fas[showNew ? 'eye-slash' : 'eye']} />
                                </Button>
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Confirm password</Form.Label>
                            <InputGroup className="bg-white">
                                <Form.Control
                                    type={showConfirm ? "text" : "password"}
                                    name="confirmPassword"
                                    value={formData.confirmPassword}
                                    onChange={handleChange}
                                />
                                <Button
                                    variant="outline-secondary"
                                    onClick={() => setShowConfirm(!showConfirm)}
                                >
                                    <FontAwesomeIcon icon={byPrefixAndName.fas[showConfirm ? 'eye-slash' : 'eye']} />
                                </Button>
                            </InputGroup>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleSave}>
                        Update Password
                    </Button>
                </Modal.Footer>
            </div>
        </Modal>
    );
};


export default ChangePassword;
